import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Logo } from '../Logo';
import { ButtonNew } from '../ButtonNew';
import { Burger } from '../Burger';
import { MobileMenu } from '../MobileMenu';
import { AccountMenu } from '../AccountMenu';
import CustomLink from '../CustomLink';
import { useRouting } from '../../shared/use-routing';
import { pagePathnames } from '../../pages/page-routes';
import { uiConfig } from '../../app-ui-config';
import styles from './HeaderNew.css';

const cx = classnames.bind(styles);

function HeaderNew({ className, isApp, isAuthenticated }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { buildPath } = useRouting();
    const { t } = useTranslation();
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    if (isApp) {
        if (isAuthenticated) {
            return (
                <header className={classes}>
                    <div className={styles.wrapper}>
                        <Logo url={buildPath(pagePathnames.dashboard)} inApp />
                        <AccountMenu />
                    </div>
                </header>
            );
        }

        return (
            <header className={classes}>
                <div className={styles.secondaryWrapper}>
                    <Logo url={buildPath(pagePathnames.dashboard)} inApp />
                </div>
            </header>
        );
    }

    return (
        <header className={classes}>
            <div className={styles.container}>
                <div className={styles.content}>
                    <Logo url={buildPath(pagePathnames.start)} inApp />
                </div>
                <nav className={styles.marketingNav} aria-label={t('common.mainNavigation')}>
                    <CustomLink
                        to={buildPath(`${pagePathnames.start}#faq`)}
                        className={styles.navLink}
                    >
                        {t('common.faq')}
                    </CustomLink>
                    <CustomLink
                        to={buildPath(`${pagePathnames.start}#reviews`)}
                        className={styles.navLink}
                    >
                        {t('common.reviews')}
                    </CustomLink>
                    <CustomLink
                        to={buildPath(pagePathnames.aboutUs)}
                        className={styles.navLink}
                    >
                        {t('common.aboutUs')}
                    </CustomLink>
                    <CustomLink
                        to={buildPath(pagePathnames.contactUs)}
                        className={styles.navLink}
                    >
                        {t('common.contactUsLink')}
                    </CustomLink>
                </nav>
                <div className={styles.actions}>
                    <div className={styles.desktopOnlyAction}>
                        <ButtonNew
                            type='text'
                            label={t('common.getStarted')}
                            link={{
                                to: uiConfig.prelanderLink,
                                target: '_blank'
                            }}
                        />
                    </div>
                    <ButtonNew
                        type='pill'
                        size='compact'
                        label={t('common.signIn')}
                        link={{ to: buildPath(pagePathnames.signIn) }}
                    />
                    <Burger
                        isOpen={isMenuOpen}
                        onClick={() => setIsMenuOpen(prevIsOpen => !prevIsOpen)}
                    />
                </div>
            </div>
            <MobileMenu
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
            />
        </header>
    );
}

HeaderNew.propTypes = {
    className: PropTypes.string,
    isApp: PropTypes.bool,
    isAuthenticated: PropTypes.bool
};

HeaderNew.defaultProps = {
    className: '',
    isApp: false,
    isAuthenticated: false
};

export {
    HeaderNew
};
